import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PaymentMethods = () => {
  return (
    <div>
      <Navbar />

      <div className="container">
        <div style={{ maxWidth: '1000px', margin: '40px auto', padding: '20px' }}>
          <h1 style={{ marginBottom: '30px', color: '#FF0000', fontSize: '32px', fontWeight: '700' }}>
            💳 Modes de Paiement
          </h1>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Paiement par Carte Bancaire (Stripe)
            </h2>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', marginBottom: '20px' }}>
              <div style={{ fontSize: '48px' }}>💳</div>
              <div style={{ flex: 1 }}>
                <p style={{ marginBottom: '15px', color: '#666', lineHeight: '1.8' }}>
                  Payez en toute sécurité avec votre carte bancaire (Visa, Mastercard, American Express) via notre partenaire de confiance Stripe.
                </p>
                <ul style={{ paddingLeft: '20px', color: '#666', lineHeight: '1.8' }}>
                  <li>Paiement sécurisé et crypté</li>
                  <li>Confirmation immédiate</li>
                  <li>Support de toutes les cartes principales</li>
                  <li>Protection contre la fraude</li>
                </ul>
              </div>
            </div>
            <div style={{ padding: '15px', backgroundColor: '#d1ecf1', borderRadius: '8px', border: '1px solid #0c5460' }}>
              <p style={{ margin: 0, color: '#0c5460', fontWeight: '600' }}>
                ⚠️ Important : Votre carte ne sera débitée qu'après validation du prix par un agent.
              </p>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Paiement Mobile Money
            </h2>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', marginBottom: '20px' }}>
              <div style={{ fontSize: '48px' }}>📱</div>
              <div style={{ flex: 1 }}>
                <p style={{ marginBottom: '15px', color: '#666', lineHeight: '1.8' }}>
                  Payez facilement avec votre compte Mobile Money (Orange Money, M-Pesa, Airtel Money, etc.).
                </p>
                <ul style={{ paddingLeft: '20px', color: '#666', lineHeight: '1.8' }}>
                  <li>Paiement rapide et simple</li>
                  <li>Pas besoin de carte bancaire</li>
                  <li>Disponible 24/7</li>
                  <li>Confirmation par SMS</li>
                </ul>
              </div>
            </div>
            <div style={{ padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
              <p style={{ margin: 0, color: '#856404' }}>
                📞 Vous recevrez les instructions de paiement par SMS après validation de votre commande.
              </p>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Processus de paiement
            </h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FF0000', 
                  color: 'white', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  1
                </div>
                <div>
                  <h3 style={{ marginBottom: '10px', color: '#333' }}>Création de la commande</h3>
                  <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                    Créez votre commande en fournissant les détails du produit et votre adresse de livraison.
                  </p>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FF0000', 
                  color: 'white', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  2
                </div>
                <div>
                  <h3 style={{ marginBottom: '10px', color: '#333' }}>Validation par un agent</h3>
                  <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                    Un agent vérifie votre commande et définit le prix final (produit + commission + livraison).
                  </p>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FF0000', 
                  color: 'white', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  3
                </div>
                <div>
                  <h3 style={{ marginBottom: '10px', color: '#333' }}>Notification et paiement</h3>
                  <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                    Vous recevez une notification avec le montant total. Cliquez sur "Payer maintenant" pour procéder au paiement.
                  </p>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FF0000', 
                  color: 'white', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  4
                </div>
                <div>
                  <h3 style={{ marginBottom: '10px', color: '#333' }}>Confirmation</h3>
                  <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                    Une fois le paiement confirmé, votre commande est traitée et expédiée.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Sécurité des paiements
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
              <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '40px', marginBottom: '10px' }}>🔒</div>
                <h3 style={{ marginBottom: '10px', color: '#333' }}>Chiffrement SSL</h3>
                <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                  Toutes les transactions sont cryptées avec SSL 256 bits
                </p>
              </div>

              <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '40px', marginBottom: '10px' }}>🛡️</div>
                <h3 style={{ marginBottom: '10px', color: '#333' }}>Protection des données</h3>
                <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                  Vos informations bancaires ne sont jamais stockées sur nos serveurs
                </p>
              </div>

              <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '40px', marginBottom: '10px' }}>✅</div>
                <h3 style={{ marginBottom: '10px', color: '#333' }}>Conformité PCI</h3>
                <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                  Conformité PCI DSS niveau 1 pour la sécurité maximale
                </p>
              </div>
            </div>
          </div>

          <div className="card">
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Questions fréquentes
            </h2>
            <div style={{ display: 'grid', gap: '15px' }}>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Puis-je payer en plusieurs fois ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Actuellement, nous n'acceptons que les paiements en une seule fois. Cependant, nous travaillons sur l'ajout d'options de paiement échelonné.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Que se passe-t-il si mon paiement est refusé ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Si votre paiement est refusé, vérifiez que votre carte a suffisamment de fonds et que les informations sont correctes. Vous pouvez réessayer ou utiliser un autre mode de paiement.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Recevrai-je une facture ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Oui, vous recevrez automatiquement une facture par email après confirmation du paiement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentMethods;





